import { useEffect, useState } from 'react';
import { Container, VStack, Box, Spinner, Alert, AlertIcon, Button, HStack, Heading, Badge } from '@chakra-ui/react';
import DOMPurify from 'dompurify';
import { api } from '../lib/api';
import { haptic } from '../telegram';

// @ts-ignore
import '../algomed-styles/lecture-content.css';

export default function RandomAlgospot() {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchOne = async () => {
    setLoading(true); setError(null);
    try { setData(await api.randomAlgospot()); haptic('select'); }
    catch (e: any) {
      haptic('error');
      if (e?.status === 429) setError('Günlük AlgoSpot limitin doldu.');
      else setError('AlgoSpot çekilemedi.');
    } finally { setLoading(false); }
  };
  useEffect(() => { fetchOne(); }, []);

  if (loading) return <VStack p={12}><Spinner size="lg" color="accent" /></VStack>;
  if (error) return (
    <Container maxW="md" py={6}>
      <Alert status="warning" borderRadius="md"><AlertIcon />{error}</Alert>
      <Button mt={4} onClick={fetchOne}>Tekrar dene</Button>
    </Container>
  );
  if (!data) return null;

  return (
    <Container maxW="2xl" py={4} px={4}>
      <VStack align="stretch" spacing={3}>
        {data.topic && <HStack><Badge colorScheme="orange">{data.topic.name}</Badge></HStack>}
        {data.title && <Heading size="md">{data.title}</Heading>}
        <Box
          className="lecture-reader"
          fontSize="md"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.content) }}
        />
        <Button mt={4} colorScheme="brand" onClick={fetchOne}>Yeni AlgoSpot</Button>
      </VStack>
    </Container>
  );
}
